import AuthLayout from '@authentication/components/AuthLayout';
import ForgotPasswordCard from '@authentication/components/molecules/ForgotPasswordCard';

function ForgotPasswordPage() {
  return (
    <AuthLayout>
      <ForgotPasswordCard />
    </AuthLayout>
  );
}

export default ForgotPasswordPage;
